export function WatermarkOverlay({ dense = false }) {
  const labels = Array.from({ length: dense ? 18 : 10 });
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      <div className="watermark-grid absolute inset-0" />
      <div className="absolute inset-x-[-30%] top-1/2 -translate-y-1/2 rotate-[-22deg] space-y-10 opacity-60">
        {labels.map((_, index) => (
          <div key={index} className="whitespace-nowrap text-center font-mono text-[10px] uppercase tracking-[0.55em] text-gold/35">
            mellowjmedia preview · protected sample · mellowjmedia preview
          </div>
        ))}
      </div>
    </div>
  );
}
